import { Route,  BrowserRouter as Router, Switch } from 'react-router-dom';
import Main from './component/main';
import LethalBlade  from './component/lethal';
import Thief from './component/thief';
import ResetPassword from './component/resetpassword';
import ChangePassword from './component/changepassword';
import Verify from './component/vertify';
import Signup from './component/signup';

function App(){
  return (<>
  <Router>
      <Switch>
          <Route exact path='/main/lethalblade' component={LethalBlade} />
          <Route exact path='/main/thief' component={Thief} />
          <Route exact path='/signup' component={Signup} />
          <Route exact path='/resetpassword' component={ResetPassword} />
          <Route exact path='/changepassword' component={ChangePassword} />        
          <Route exact path='/verify' component={Verify} />
          <Route>
              <Main/>
          </Route>
      </Switch>
  </Router>
  </>);
}

export default App;


